<template>
  <z-container fluid>
    
    <h3 class="text-body-1 mb-3">Recebimento Cliente</h3>

    <v-card class="mb-3">
      <v-toolbar flat color="white" dense>
        <h3 class="text-subtitle-2">Cliente</h3>
      </v-toolbar>
      <v-divider></v-divider>

      <v-card-text>
        <v-row dense>
          <v-col sm="2">
            <v-text-field label="Cliente Código" v-model="cliente.id" readonly hide-details filled dense></v-text-field>
          </v-col>
          <v-col sm="8">
            <v-text-field label="Nome" v-model="cliente.razao" readonly hide-details filled dense></v-text-field>
          </v-col>
          <v-col sm="2">
            <z-campo-valor v-model="cliente.haver" placeholder=" " label="Créditos" ref="credidos" readonly hide-details filled dense></z-campo-valor>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="mb-3">
      <v-toolbar flat color="white" dense>
        <h3 class="subtitle-2">Promissórias ({{ promissorias.length }})</h3>
        <v-spacer></v-spacer>
        <v-btn depressed color="primary" @click="incluirPromissorias">
          Adicionar Promissória
        </v-btn>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text class="pa-0">

        <v-data-table
          :items="promissorias"
          :headers="headers"
          hide-default-footer
          disable-pagination
          item-key="id"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.documento }}</td>
              <td>{{ props.item.forma_pagamento}}</td>
              <td>{{ props.item.vencimento | dataBR}}</td>
              <td class="text-right">{{ props.item.valor | valorBR}}</td>
              <td class="text-right">{{ props.item.valor_restante | valorBR}}</td>
              <td class="text-right">{{ props.item.pagamento | valorBR}}</td>
              <td class="text-right">{{ props.item.saldo | valorBR}}</td>
              <td class="text-right">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon class="ma-0" @click="remover(props.item)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Remover Promissória</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:body.append="{items}">
            <tr>
              <td></td>
              <td class="text-right" colspan="4"><b>{{ somaRestante | valorBR }}</b></td>
              <td class="text-right"><b>{{ somaPagamentosPromissorias | valorBR }}</b></td>
              <td class="text-right"><b>{{ somaSaldo | valorBR }}</b></td>
              <td></td>
            </tr>
          </template>
        </v-data-table>

      </v-card-text>
    </v-card>

    <v-card style="margin-bottom: 200px">
      <v-toolbar flat color="white" dense>
        <h3 class="subtitle-2">Recebimentos</h3>
        <v-spacer></v-spacer>
        <v-btn depressed color="primary" @click="novoRecebimento" :disabled="somaSaldo == 0">
          Adicionar Recebimento
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>

      <v-card-text class="pa-0">

        <v-data-table
          :headers="headersPagamentos"
          :items="pagamentos"
          hide-default-footer
          item-key="id"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.data | dataBR}}</td>
              <td>{{ props.item.forma_pagamento}}</td>
              <td class="text-right">{{ props.item.valor | valorBR}}</td>
              <td class="text-right">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon class="ma-0" @click="removerRecebimento(props.item)">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Remover</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:body.append="props">
            <tr>
              <td class="text-right" colspan="3"><b>{{ somaPagamentos | valorBR }}</b></td>
              <td></td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$router.back()" :disabled="$store.state.loading">Cancelar</v-btn>
        <v-btn depressed color="primary" @click="finalizar" :loading="$store.state.loading" :disabled="podeFinalizar">Finalizar</v-btn>
      </v-card-actions>
    </v-card>

    <z-dialogo ref="dialogoAdicionarPromissoria" titulo="Adicionar Promissória" :dividers="true" largura="1024px" altura="400px" scrollable>
      <div slot="texto">
        <z-loading :loading="loading" height="100px" color="primary"></z-loading>
        <h3 class="subtitle-2 text-center mt-5" v-if="!loading && listaPromissoriasEmAberto.length == 0">Não há mais promissórias a receber desse cliente</h3>
        <v-data-table v-if="!loading && listaPromissoriasEmAberto.length > 0"
          :headers="headersEmAberto"
          :items="listaPromissoriasEmAberto"
          hide-default-footer
          item-key="id"
          show-select
          v-model="selected"
          disable-pagination
        >
          <template v-slot:item="props">
            <tr :active="props.selected" @click="props.select(!props.isSelected)" style="cursor: pointer">
              <td>
                <v-simple-checkbox :value="props.isSelected" @input="props.select(!props.isSelected)" color="primary"></v-simple-checkbox>
              </td>
              <td>{{ props.item.documento }}</td>
              <td>{{ props.item.forma_pagamento}}</td>
              <td>{{ props.item.vencimento | dataBR}}</td>
              <td class="text-right">{{ props.item.valor | valorBR}}</td>
              <td class="text-right">{{ props.item.valor_restante | valorBR}}</td>
              <td>{{ props.item.observacoes }}</td>
              <!-- <td class="text-right">{{ props.item.saldo | valorBR}}</td> -->
            </tr>
          </template>
        </v-data-table>
      </div>

      <div slot="actions_left">
        <span class="subtitle-2">
          Total selecionado: <b>{{ selected.reduce((soma, sel) => soma + sel.valor_restante, 0) | valorBR}}</b>
        </span>
      </div>

      <v-btn text @click="$refs.dialogoAdicionarPromissoria.fechar()">Cancelar</v-btn>
      <v-btn color="primary darken-1" depressed @click="confirmarPromissorias">Confirmar</v-btn>
    </z-dialogo>

    <z-dialogo ref="dialogoAdicionarRecebimento" titulo="Adicionar Recebimento" :dividers="true" largura="700px">
        <div slot="texto">
          <!-- <v-container grid-list-md> -->
            <v-form  v-model="valido" ref="form" class="v-form">
                <v-row dense>
                  <v-col sm="4">
                    <z-date-picker-menu class="mr-2" v-model="pagamento.data" label="Data" placeholder=" " :rules="regras.data" :readonly="!config.ALTERAR_DATA_AO_LANCAR_RECEBIMENTO" filled dense></z-date-picker-menu>
                  </v-col>
                  <v-col sm="4">
                    <v-select class="mx-2" v-model="pagamento.forma_pagamento" label="Forma de Pagamento" :items="$globals.FORMAS_DE_PAGAMENTO_CAIXA.concat(['Desconto'])" filled dense></v-select>
                  </v-col>
                  <v-col sm="4">
                    <z-campo-valor class="ml-2" v-model="pagamento.valor" ref="valor" label="Valor" placeholder=" " :rules="regras.valor" @keyup.enter="confirmarRecebimento" filled dense></z-campo-valor>
                    <!-- <v-text-field class="ml-2" v-model="pagamento.valor" ref="valor" label="Valor" placeholder=" " :rules="regras.valor"></v-text-field> -->
                  </v-col>
                </v-row>
            </v-form>
          <!-- </v-container> -->
        </div>
        <v-btn text @click="$refs.dialogoAdicionarRecebimento.fechar()">Cancelar</v-btn>
        <v-btn color="primary darken-1" depressed @click="confirmarRecebimento" :disabled="!valido">Confirmar</v-btn>
    </z-dialogo>

    <z-dialogo ref="dialogoUsarHaver" titulo="Usar haver" :dividers="true" largura="700px">
        <div slot="texto">
          <v-container>
            <p class="body-2">Este cliente possue um haver de R$ {{ this.cliente.haver | valorBR }}.</p>
            <p class="body-2">Deseja usá-lo?</p>
          </v-container>
        </div>
        <v-btn text @click="$refs.dialogoUsarHaver.fechar(); novoRecebimento(false)">Não</v-btn>
        <v-btn color="primary darken-1" text @click="confirmarHaver">Sim</v-btn>
    </z-dialogo>

    <z-dialogo-sim-nao ref="dialogoGerarHaver" titulo="Gerar haver" :dividers="true" largura="700px">
      <div class="text--primary">
        <p class="body-2">O valor pago é maior que o valor a receber.</p>
        <p class="body-2">Deseja gerar um haver de R$ {{ this.valorHaver | valorBR }} para o cliente?</p>
      </div>
    </z-dialogo-sim-nao>

    <z-dialogo-sim-nao ref="dialogoFinalizarRecebimento" titulo="Finalizar Recebimento" :dividers="true" largura="700px">
      <p class="body-2">Deseja concluir esse recebimento?</p>
    </z-dialogo-sim-nao>

  </z-container>
</template>

<script>
  import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
  export default {
    name: 'recebimento-promissorias',
    data: () => ({
      pagamento: {
        data: '',
        forma_pagamento: 'Dinheiro',
        valor: 0
      },
      // promissorias: [],
      // pagamentos: [],
      headers: [
        { text: 'Documento', value: 'documento', width: '80px', sortable: false },
        { text: 'Tipo', value: 'forma_pagamento', sortable: false },
        { text: 'Vencimento', value: 'vencimento', width: '100px', sortable: false },
        { text: 'Valor', value: 'valor', align: 'right', width: '150px', sortable: false },
        { text: 'Restante', value: 'valor_restante', align: 'right', width: '130px', sortable: false },
        { text: 'Recebimentos', value: 'pagamento', align: 'right', width: '110px', sortable: false },
        { text: 'Saldo', value: 'saldo', align: 'right', width: '110px', sortable: false },
        { text: 'Opções', value: '', align: 'right', sortable: false }
      ],
      headersEmAberto: [
        { text: 'Documento', value: 'documento', width: '80px', sortable: false},
        { text: 'Tipo', value: 'forma_pagamento', sortable: false },
        { text: 'Vencimento', value: 'vencimento', width: '80px', sortable: false },
        { text: 'Valor', value: 'valor', align: 'right', width: '80px', sortable: false },
        { text: 'Restante', value: 'valor_restante', align: 'right', width: '80px', sortable: false },
        { text: 'Observações', value: 'observacoes', sortable: false },
      ],
      headersPagamentos: [
        { text: 'Data', value: 'data',  width: '150px', sortable: false},
        { text: 'Tipo', value: 'forma_pagamento', sortable: false },
        { text: 'Valor', value: 'valor', align: 'right', width: '150px', sortable: false },
        { text: 'Opções', value: '', align: 'right', sortable: false }
      ],
      loading: false,
      selected: [],
      valido: false,
      regras: {
        data: [v => !!v || 'Informe uma data'],
        valor: [v => (v != '0,00') || 'Digite o valor do pagamento']
      }
    }),

    beforeRouteLeave(to, from, next) {
      this.limparPagamentosPromissorias();
      
      if (to.name != 'ExtratoCliente') {
        this.$store.commit('financeiro/SET_DRAWER_CLIENTES', false);
      }

      next();
    },

    mounted() {
      this.setTitulo('Recebimentos');
      if (!this.cliente.id) {
        this.$router.push('/financeiro/extratocliente');
      }

      this.$vuetify.goTo(0);
      this.$store.commit('financeiro/SET_DRAWER_CLIENTES', true);
    },

    methods: {
      ...mapMutations(['setTitulo']),
      ...mapMutations('recebimentos', ['adicionarPromissoria', 'adicionarRecebimento', 'removerRecebimento', 'removerPromissoria', 'atualizarPagamentosPromissorias', 'limparPagamentosPromissorias', 'SET_PROMISSORIA']),
      ...mapActions('recebimentos', ['listarPromissoriasEmAberto', 'finalizarRecebimento']),
      ...mapActions('financeiro', ['extratocliente']),
      ...mapActions({
        abrirCliente: 'clientes/abrir'
      }),

      async incluirPromissorias() {
        this.loading = true;
        this.selected = [];
        this.$refs.dialogoAdicionarPromissoria.abrir();
        await this.listarPromissoriasEmAberto(this.cliente.id);
        this.loading = false;
      },

      confirmarPromissorias() {
        this.selected.forEach(promissoria => {
          this.adicionarPromissoria(this.clone(promissoria));
        });

        this.$refs.dialogoAdicionarPromissoria.fechar();
        // this.$vuetify.goTo(7000);
      },

      novoRecebimento(haver = true) {
        if (this.cliente.haver > 0 && haver) {
          this.$refs.dialogoUsarHaver.abrir();
        } else {
          // this.$refs.form.reset();
          this.$refs.dialogoAdicionarRecebimento.abrir();
          this.setFocus('valor');
          this.formReset();
        }
      },

      confirmarRecebimento() {
        if (this.$refs.form.validate()) {
          this.adicionarRecebimento(this.pagamento);
          this.$refs.dialogoAdicionarRecebimento.fechar();
          // this.$vuetify.goTo(7000);
        }
      },

      finalizar(){
        // this.$refs.dialogoFinalizarRecebimento.abrir()
          // .then(response => {

            // if (response == true) {
              this.confirmarFinalizar();
            // }
          // });
      },

      async confirmarFinalizar() {
        if (this.valorHaver > 0) {
          await this.$refs.dialogoGerarHaver.abrir()
            .then(response => {
              if (response) {
                this.$store.commit('recebimentos/setGerarHaver', true);
              } else {
                this.$store.commit('recebimentos/setGerarHaver', false);
              }
            });
        }

        try {
          this.loading = true;
          await this.finalizarRecebimento(this.cliente.id);
          this.$eventbus.notificar('Recebimento finalizado.');
          this.extratocliente(this.cliente.id);
          this.abrirCliente(this.cliente.id);
          this.$router.push('/financeiro/extratocliente');
        } catch (erro) {
          this.$eventbus.erro('Não foi possível finalizar o recebimento.', erro);
        } finally {
          this.loading = false;
        }
      },

      confirmarHaver() {
        let valor = this.cliente.haver < this.somaSaldo ? this.cliente.haver : this.somaSaldo
        this.pagamento = {
          data: this.$moment().format('YYYY-MM-DD'),
          forma_pagamento: 'Haver',
          valor: valor
        }

        this.cliente.haver = this.cliente.haver - valor;

        this.adicionarRecebimento(this.pagamento);
        this.$refs.dialogoUsarHaver.fechar();
        this.$vuetify.goTo(7000);
      },

      remover(promissoria) {
        this.removerPromissoria(promissoria);
      },

      formReset() {
        this.pagamento = {
          data: this.$moment().format('YYYY-MM-DD'),
          forma_pagamento: 'Dinheiro',
          valor: this.somaSaldo
        }
      }
    },

    computed: {
      ...mapState('clientes', { cliente: 'cliente' }),
      ...mapState('recebimentos', ['promissoriasEmAberto', 'promissorias', 'pagamentos']),
      ...mapGetters('recebimentos', ['listaPromissoriasEmAberto', 'somaPagamentos', 'somaPromissorias', 'somaRestante', 'somaPagamentosPromissorias', 'somaSaldo']),
      
      podeFinalizar() {
        return this.somaPagamentos > 0 && this.somaPromissorias > 0 ? false : true;
      },

      valorHaver() {
        return this.somaPagamentos - this.somaRestante;
      },

      config() {
        return this.$store.state.configuracoes;
      },
    },

    watch: {
        pagamentos() {
          this.atualizarPagamentosPromissorias();
        },

        promissorias() {
          this.atualizarPagamentosPromissorias();
        }
    }
  }
</script>

<style scoped>

</style>